import React, { useState } from 'react';

import { v4 as uuidv4 } from 'uuid';
import { Notification, Button, Typography } from '@telus-uds/components-web';

import {
  ButtonLink,
  GroupOverlay,
  TableContainer,
  GroupOverlayInner,
  ButtonWrapper,
  Title,
  FlexRow,
  ButtonLight,
  ButtonLinkDelete
} from './css';
import Service from './service';
import AddSVG from '../assets/svg/add';
import GroupLabel from './groupLabel';
import DeleteSVG from '../assets/svg/delete';
import { deleteServiceGroup } from './saveSchemaToDB';

export default function ServiceGroup({
  groupData,
  offeringId,
  groupIndex,
  setSavingData,
  fullyManagedAdminData,
  setFullyManagedAdminData
}) {
  const {
    name: groupName,
    isSaved,
    ServicesInGroup: serviceList = []
  } = groupData;
  const [showOverlay, setShowOverlay] = useState(false);
  const groupId = groupData.id;
  const handleAddService = () => {
    const clonedAdminData = JSON.parse(JSON.stringify(fullyManagedAdminData));
    clonedAdminData[groupIndex].ServicesInGroup.push({
      groupId: groupData.id || '',
      offeringId,
      id: '', // serviceId
      name: '',
      ord:'', // Service Index
      productCatalogQuantities: [{
        serviceId: '',
        id:'',
        isRequired:false,
        name: ''
    }],
      isSaved: false,
      productCatalogQuestions: [
        {
          offeringId,
          serviceId: '',
          id: '',
          ord:'',
          name: '',
          note: '',
          isSaved: false,
          isRequired: false,
          productCatalogOptions: [
            {
              questionId: '',
              id: '',
              ord:'',
              name: '',
              productCatalogPricings: [{
                id:'',
                optionId: '',
                cost: 0,
                onetimePrice: 0,
                costPremium: 0,
                onetimePricePremium: 0,
                operationType: 'ADD'
              }]
            }
          ]
        }
      ]
    });
    setFullyManagedAdminData(clonedAdminData);
  };

  const handleDeleteServiceGroup = () => {
    const clonedAdminData = JSON.parse(JSON.stringify(fullyManagedAdminData));
    const serviceGroupId = clonedAdminData[groupIndex].id;
    if (serviceGroupId) deleteServiceGroup(serviceGroupId);
    clonedAdminData.splice(groupIndex, 1);
    setFullyManagedAdminData(clonedAdminData);
    setShowOverlay(false);
  };

  return (
    <TableContainer>
      {showOverlay && (
        <GroupOverlay>
          <GroupOverlayInner>
            <Title>
              Deleting this category will also delete all services under it. Are
              you sure you want to proceed?
            </Title>
            <ButtonWrapper>
              <Button variant={{ priority: 'low' }} onClick={() => setShowOverlay(false)}>
                Cancel
              </Button>
              <Button onClick={handleDeleteServiceGroup}>Delete</Button>
            </ButtonWrapper>
          </GroupOverlayInner>
        </GroupOverlay>
      )}
      <FlexRow justify="space-between">
        <GroupLabel
          groupLabel={groupName}
          offeringId={offeringId}
          groupIndex={groupIndex}
          setSavingData={setSavingData}
          fullyManagedAdminData={fullyManagedAdminData}
          setFullyManagedAdminData={setFullyManagedAdminData}
        />
        <ButtonLinkDelete onClick={() => setShowOverlay(true)}>
          <DeleteSVG size="19" color="#c12335" />
          <Typography>Delete Category</Typography>
        </ButtonLinkDelete>
      </FlexRow>
      {groupId && serviceList.map((serviceItem, index) => (
        <Service
          key={serviceItem.id}
          offeringId={offeringId}
          serviceData={serviceItem}
          groupIndex={groupIndex}
          serviceIndex={index}
          setSavingData={setSavingData}
          fullyManagedAdminData={fullyManagedAdminData}
          setFullyManagedAdminData={setFullyManagedAdminData}
        />
      ))}
      <hr />
      {groupId && <ButtonLight onClick={handleAddService}>
        <AddSVG size={18} />
        Add service
      </ButtonLight>}
      {!groupId && (
        <Notification variant={{ validation: 'warning' }} copy="en">
          <Typography variant={{ bold: true }}>
            Note: Service group should not be saved without adding the service group
            label and at least one service.
          </Typography>
        </Notification>
      )}
    </TableContainer>
  );
}
